import React from 'react';
import { Avatar } from 'antd';
import { AndroidOutlined } from '@ant-design/icons';
import Config from "../../../config";

export const AppHeader = (props) => {

    let avatarProps = {
        shape: 'square',
        icon: <AndroidOutlined />,
        size: 76,
    };

    if (props.media) {
        const icon = props.media.filter(i => i.type === 'icon');
        if (icon.length > 0) {
            avatarProps.src = `${Config.MEDIA.IMAGES}/${icon[0].hash}/medium`;
        }
    }

    return (
        <div className={`app--block app--block__bg app--block__header`}>
            <div className="header__column app__header">
                <Avatar {...avatarProps}/>
                <div className={`app--info`}>
                    <div className="title">{props.title}</div>
                    {props.app_id && (<div className="app_id">{props.app_id}</div>)}
                </div>
            </div>
            <div className="header__column app_stats">
                <div className="label">Статус</div>
                <div className={`status`}>{props.status}</div>
            </div>
            <div className="header__column app_stats">
                <div className="label">Установок</div>
                <div className={`install`}>{props.installs_count}</div>
            </div>
        </div>
    );
}